var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 17.7,
    cy: 21.3,
    r: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M21.8 25.7V34c0 1.6-1.3 2.8-2.8 2.8h-3.2c-1.6 0-2.8-1.3-2.8-2.8v-8.3H4.6c-1.6 0-2.8-1.3-2.8-2.8v-3.2c0-1.6 1.3-2.8 2.8-2.8h8.3V8.5c0-1.6 1.3-2.8 2.8-2.8h3.2c1.6 0 2.8 1.3 2.8 2.8v8.3h5.6c1.6 0 3.1 1.3 3.1 2.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M21.8 25.7V34c0 1.6-1.3 2.8-2.8 2.8h-3.2c-1.6 0-2.8-1.3-2.8-2.8v-8.3H4.6c-1.6 0-2.8-1.3-2.8-2.8v-3.2c0-1.6 1.3-2.8 2.8-2.8h8.3V8.5c0-1.6 1.3-2.8 2.8-2.8h3.2c1.6 0 2.8 1.3 2.8 2.8v8.3h5.6c1.6 0 3.1 1.3 3.1 2.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M38.6 25.7H21.8M36.4 21.3l4.3 4.4-4.3 4.4M38.6 25.7H21.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M36.4 21.3l4.3 4.4-4.3 4.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddparent);
export default __webpack_public_path__ + "static/media/addparent.39085cb61f1e3b7d81b98b200ef84d9a.svg";
export { ForwardRef as ReactComponent };